import { HomeFloodIcon } from './HomeFloodIcon';

/**
 * author: Google
 * id AC4506FC-3368-416C-8E9A-BADD6F66E7D5
 * name home-flood
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-flood.svg
 * tags
 * - Weather 
 * - Home Automation 
 * - Nature 
 */
export const HouseFloodIcon = HomeFloodIcon;
export default HouseFloodIcon